import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsTarget } from '@fcom/core-api';

@Component({
  selector: 'fin-text-link',
  templateUrl: './text-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextLinkComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input()
  teaserTitle$: Observable<string>;
  @Input()
  target$: Observable<CmsTarget>;
  @Input()
  colorClass: string;

  @Output()
  click: EventEmitter<void> = new EventEmitter<void>();
}
